'use strict';

import { Injectable, Inject } from 'ng-metadata/core';
import {UserSessionManagerService} from '../security/userSessionManager.service';
import {preventStateReload} from '../infra/annotations';
import {JwtUtilService} from '../security/jwtUtil.service';
import {ConfigurationUtil} from '../nddUtils/configurationUtil.service';
import {SearchService} from '../search/search.service';
import {getVid} from '../appConfig/appConfigForward';
import {RtaService} from '../search/rta.service';
import {PrimoResponse} from '../infra/dataStructures/PrimoResponses/favorite.interface';
import {PrimoResponse as PI} from '../infra/dataStructures/PrimoResponses/doc.interfcae';
import {DateUtils} from "../nddUtils/dateUtils.service";
import {PrimolyticsService, beacon} from '../analytics/primolytics.service';
import {QuickLink} from "../search/quickLink/quickLink.service";

const _orderBy = require('lodash/orderBy');
const _get = require('lodash/get');

const difference = require('lodash/difference');
const extend = require('lodash/extend');
const indexOf = require('lodash/indexOf');
const intersection = require('lodash/intersection');
const keys = require('lodash/keys');
const isEmpty = require('lodash/isEmpty');
const filter = require('lodash/filter');
const includes = require('lodash/includes');
const toLower = require('lodash/toLower');

const Subject= require('rxjs/Subject').Subject;
const Observable= require('rxjs/Observable').Observable;
require('rxjs/add/observable/fromPromise');
require('rxjs/add/operator/concatMap');


@Injectable()
export class LoansRequestParams{
    public type;
    public bulk;
    public offset;
    public inst;
    public lang;
}

@Injectable()
export class FavoritesService{
    private requestParams:LoansRequestParams;
    unlabeled: Number;
    totalItems: Number;
    labels: Object;
    records: PrimoResponse.FavoritesRecord[];
    items: Object[] = [];
    sortedLabels: Object[];
    private GET_LABELS_URL:string;
    private start:boolean;
    unlabeledRecords: boolean = false;
    private isFirstBulk: boolean = false;
    needToChangeUrl: boolean = false;
    allItems: boolean = true;
    allItemsLoaded: boolean = false;
    _user: boolean = false;
    firstBulk: number = 0;
    countRecords: number = 0;
    bulkSize: number = 10;
    private fullList: Object[];
    private _favoritesInProgress: boolean = false;
    private _isSelectAllDone: boolean = true;
    private _isFetchingAllItems: boolean = false;
    selectedLabels: string[];
    private vid:string= getVid();
    private keysLabels: string[];
    private from:number;
    private to:number;
    private recordsId: string[];
    private _sortInProgress:boolean = false;
    private isMore:boolean;
    private _sortBy: string;
    private  guestRecordsIdsOrder: string[];
    private recordsIdBulk: string[];
    private _unpinFromFav: boolean = false;
    private searchCancelDeferredObject: ng.IDeferred<any>;
	searchPerformed: boolean;
	resetSearchTerms: boolean;

    public QUERIES_TAB_NAME= 'queries';
    public SEARCH_HISTORY_TAB_NAME= 'search_history';
    public ITEMS__TAB_NAME= 'items';
    private favoritesTab = this.ITEMS__TAB_NAME;
    private sortOptions = ["date","title","author"];
    private promiseObservable: Subject<any>;
    private inLabelsSearch: boolean = false;

    constructor(@Inject('$http') private $http : angular.IHttpService,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
                private userSessionManagerService : UserSessionManagerService,
                private jwtUtilService: JwtUtilService,
                @Inject('$location') private $location : ng.ILocationService,
                @Inject('$stateParams') private $stateParams : ng.ui.IStateParamsService,
                @Inject('restBaseURLs') private restBaseURLs,
                private configurationUtil: ConfigurationUtil,
                private searchService: SearchService,
                private primolyticsService: PrimolyticsService,
                private rtaService: RtaService,
                @Inject('accountListBulkSize') private accountListBulkSize,
                private dateUtil: DateUtils,
                private quickLinkService: QuickLink,
                @Inject('$q') private $q: ng.IQService) {
        this.GET_LABELS_URL= restBaseURLs.favoritesBaseURL;
        this.isMore = false;

        this.promiseObservable= new Subject();
        this.promiseObservable.concatMap((observable)=>{
            return observable;
        }).subscribe((response)=>{
            this.handleResponse(response);
        });

    }
    
    updateRecordLabelsAndFacetLabelsList(updatedRecordId, labels, label,  operation){
        
        //  Update facet labels list by checking operation value is Added or Removed
        if(operation === "Added"){
            this.labels[label] = (this.labels.hasOwnProperty(label)) ? this.labels[label] + 1 : 1;
            if(labels.length === 1){
                this.unlabeled = this.unlabeled.valueOf() - 1;
            }
        }      
        if(operation === "Removed"){
            (this.labels[label] - 1 === 0) ?  delete this.labels[label] :  this.labels[label] = this.labels[label] - 1;        
            if(labels.length === 0){
                this.unlabeled = this.unlabeled.valueOf() + 1;
            }
        }
   
        // Update record labels      
        this.setLabelsOfRecord(updatedRecordId, labels);
      
        // Sort labels by lower case (without the "unlabeled" label - suppose to be at the beginning)
        this.keysLabels = keys(this.labels);
        this.sortedLabels = this.keysLabels.filter(key => key != 'unlabled')
                                                                   .map((k)=> [k,k.toLowerCase()])
                                                                   .sort((a,b) => a[1].localeCompare(b[1]))
                                                                   .map(k=> [k[0],this.labels[k[0]]]);

        // Update 'unlabeled items' label in facet labels list
        // if > 0 --> Insert the "unlabeled" label to the beginning of facet list, else --> delete this label
        (this.unlabeled > 0) ? this.sortedLabels.unshift(["unlabled", this.unlabeled]) : delete this.labels['unlabled'];
    }

    getItemsFromServer(sortBy){
        this.allItemsLoaded = false;
        this.isFirstBulk = true;
        this.updateLabelsFromAPI()
            .then(() => {
                /*Sort favorits in case the URL has a sort by parameter*/
                this.sortFavFromURL(sortBy);
                this.returnAllOrFilter();
            });
    }


    public updateLabelsFromAPI(searchPerformed) {
        return this.$http.get(this.GET_LABELS_URL).then(
            (response: { data: PrimoResponse.IFavorites }) => {
                let data: PrimoResponse.IFavorites = response.data;
                this.records = data.records;
                this.unlabeled = data.unlabeledRecords;
                this.labels = data.labels;
                /* if (this.unlabeled > 0){
                    this.labels = extend({"unlabled": this.unlabeled}, this.labels);

                 }*/
                this.keysLabels = keys(this.labels);
                // sort with out the "unlabeled key"- suppose to be in the beginning
                // sort by lower case
                this.sortedLabels = this.keysLabels
                    .map((k) => [k, k.toLowerCase()])
                    .sort((a, b) => a[1].localeCompare(b[1]))
                    .map(k => [k[0], this.labels[k[0]]]);

                if (this.unlabeled > 0) {
                    this.labels = extend({"unlabled": this.unlabeled}, this.labels);
                    this.keysLabels = keys(this.labels);
                    this.sortedLabels.unshift(["unlabled", this.unlabeled]);

                }
				if (!searchPerformed) {
                	this.totalItems = data.totalItems;
				}
                this.recordsId = this.records.map(function (a) {
                    return a.recordId;
                });
                if (this.$stateParams['label'] == undefined) {
                    this.selectedLabels = [];
                    this.unlabeledRecords = false;
                } else {
                    this.selectedLabels = this.initSelectedLabels(this.$stateParams['label']);
                    this.IsUrlChangeNeeded();
                    this.unpinFromFav = false;
                    this.unlabeledRecords = (this.selectedLabels.indexOf("unlabled") != -1) ? true : false;
                }
            });
    }

    IsUrlChangeNeeded() {
        let change = (difference(this.selectedLabels, this.keysLabels));
        if (change.length > 0) {
            this.changeUrL(change);
         }
     }


    @preventStateReload
    changeUrL(change) {
         let newUrl = this.$location.url();
         let index, encode;
         for (let i = 0; i < change.length; i++) {
             index = indexOf(this.selectedLabels,change[i]);
             this.selectedLabels.splice(index, 1);
             encode = encodeURIComponent(change[i]);
             newUrl = newUrl.replace("&label="+encode,"");
         }
         this.needToChangeUrl = true;
         this.$location.url(newUrl);
   }




    initSelectedLabels(labels) {
         if (Array.isArray(labels)) {
            return labels
          }
        return [labels];

     }

    getFirstBulkOfAllItems() {
        this.fullList = this.recordsId;
        this.to = Math.min(((this.unpinFromFav)? this.to : this.bulkSize), this.recordsId.length);
        if(this.unpinFromFav && this.to === this.fullList.length){
            this.allItemsLoaded = true;
        }
        this.start = true;
        this.getPnxRecordFromRecordId(this.recordsId.slice(this.firstBulk,this.to));
    }


    getLabels(){
      return this.labels;
    }

    getSortedLabels() {
         return this.sortedLabels;
     }

    getTotalItems(){
        return this.totalItems;
     }


     getItems(){
          return this.items;
     }

    getRecords() {
        return this.records;
    }

    getLabelsOfRecord(id){
        for (let i = 0; i < this.records.length; i++) {
              if (this.records[i].recordId == id) {
                return this.records[i].labels;
               }
         }
        return [];
     }
    
    setLabelsOfRecord(id, labels){
        for (let i = 0; i < this.records.length; i++) {
              if (this.records[i].recordId == id) {
                  this.records[i].labels = labels;
               }
         }
     }

    getOtherLabels(id){
        let labels = keys(this.labels);
        let otherLabels = [];
        let userLabels = this.getLabelsOfRecord(id);
        for (let i = 0; i < labels.length; i++) {
           if ((userLabels.indexOf(labels[i]) == -1) && (labels[i] != "unlabled") ) {
               otherLabels.push(labels[i])
            }
       }
        return otherLabels;
      }


	public searchInList(searchTerm) {
		this.selectedLabels = [];
       	this.unlabeledRecords = false;
		this.searchPerformed = true;
		let filtered_array = filter(this.getRecords(),(o) => {
			let term = toLower(searchTerm);
			/* check in author */
			if (includes(toLower(o.author),term)) {
				return true;
			}
			
			/* check in title */
			if (includes(toLower(o.title),term)) {
				return true;
			}
			
			/* check in labels */
			if (!o.labels) {
				return false;
			}
			
			let match = false;
			o.labels.forEach((label) => {
				if (includes(toLower(label),term)) {
					match = true;
				}
			})
		    return match;
		});
		
		this.recordsId = filtered_array.map(function (a) {
             return a.recordId;
        });

		this.getFirstBulkOfAllItems()
		this.totalItems = filtered_array.length;
		this.allItems = true;
	}

	public resetSearch(isReloadRecords) {
		this.searchPerformed = false;
		this.allItemsLoaded  = false;
		if (!this.getRecords()) {
			return;
		}
		this.recordsId = this.getRecords().map(function (a) {
             return a.recordId;
        });
		this.totalItems = this.recordsId.length;
		
		if (isReloadRecords) {
			this.getFirstBulkOfAllItems();
		}
		this.getItems().filter(this.filterObject, this);
	}
	
    private filterObject(obj, i) {
          if (!isEmpty(obj)){
               return obj;
          }
       }


    private getPnxRecordFromRecordId(records){
        this.recordsIdBulk = records;
        if (records.length > 0) {
            if (this.searchCancelDeferredObject && this.inLabelsSearch) {
                this.searchCancelDeferredObject.resolve('there is a newer search than the one we are trying to get facets for so this facets request is irrelevant');
            }
            this.inLabelsSearch = true;
            this.searchCancelDeferredObject = this.$q.defer();
            let url = this.restBaseURLs.pnxBaseURL + '/U?recordIds=' + encodeURIComponent(records) + '&vid=' + this.vid + '&lang=' + this.$translate.use();
            this.promiseObservable.next(Observable.fromPromise(this.$http
                .get(url,
                    {timeout: this.searchCancelDeferredObject.promise})
                .catch(err => {})
                .finally(() => {
                    this.inLabelsSearch = false;
                })
            ));
        }
        else {
            this.items = [];
        }
    }

     handleResponse(response){
        if(!response) {
            return {};
        }
        let data: any[] = response.data;
		data = data.filter(this.filterObject, this);
        if (data.length < this.recordsIdBulk.length) {
            // This case will happened in Primo VE when a record is in the DB but removed from the index.
            // The purpose of this mapping is to compare the behavior to Primo.
            let responseRecordIds = data.map(e => e.pnx.control.recordid["0"] || undefined);
            data = this.recordsIdBulk.map(recId => {
                let indexInResponse = responseRecordIds.indexOf(recId);
                if (indexInResponse > -1) {
                    responseRecordIds[indexInResponse] = '';
                    return data[indexInResponse];
                } else {
					let favoriteArray = filter(this.records,(record) => { 
						return record.recordId === recId; 
					});
					let favoriteObj = favoriteArray ? favoriteArray[0] : {};
					
                    return {status:'deleted', favorite : favoriteObj}
                }
            });
        }

        if (this.configurationUtil.getLocationsConfiguration() && this.configurationUtil.getLocationsConfiguration().rta !== 'none') {
            this.rtaService.updateAvailability(data);
        }
        if (this.quickLinkService.isUnpaywallLinksAvailable(data)) {
            this.quickLinkService.updateUnpaywallLinks(data);
        }

        if(this.searchService.isbriefResultsJournalCoverageEnabledInPrimo()){
            // Prepare records for edelivery call (journal coverage addition)
            let recordsDataForFavEdelivery = [];
            data.forEach(doc => {
				if(doc.status != 'deleted') 
                	// Prepare records for edelivery call (journal coverage addition)
                	recordsDataForFavEdelivery = recordsDataForFavEdelivery.concat(this.searchService.prepareRecordsForEdeliveryCall(doc));
            });

            if(recordsDataForFavEdelivery && recordsDataForFavEdelivery.length > 0){
                // update consolidated coverage for deeplinks ( Fulldisplay / Permalink / Fetch item ) - Here we will send single record
                this.searchService.primoDeliveryBulkCall(recordsDataForFavEdelivery, data);
            }
        }


         if (this.start) {
             this.items = data;
         }
         else {
             this.items = this.items.concat(data);
         }

         this.isFirstBulk = false;
     }
	
    returnPnxForRecords(records) {
         if (records.length > 0) {
           let url= this.restBaseURLs.pnxBaseURL+'/U?recordIds=' + records +'&vid=' + this.vid+'&lang=' + this.$translate.use();
           return this.$http.get(url);
         }
         return undefined;
    }

   getFullList() {
        return this.fullList;
    }

   get favoritesInProgress() {
       return this._favoritesInProgress;
   }

   set favoritesInProgress(progress) {
       this._favoritesInProgress = progress;
   }
    
    get isSelectAllDone() {
        return this._isSelectAllDone;
    }

    set isSelectAllDone(isSelectAllDone) {
        this._isSelectAllDone = isSelectAllDone;
    }


    get isFetchingAllItems() {
        return this._isFetchingAllItems;
    }

    set isFetchingAllItems(isFetchingAllItems) {
        this._isFetchingAllItems = isFetchingAllItems;
    }

    getItemsFromLocalForage(user,sortBy) {
          this.allItemsLoaded = false;
          this.isFirstBulk = true;
          this.userSessionManagerService.createOrGetUserArea(user).then((data) => {
               if (this.configurationUtil.getLocationsConfiguration() && this.configurationUtil.getLocationsConfiguration().rta !== 'none') {
                   this.rtaService.updateAvailability(data);
              }
              this.fullList = data;
              this.totalItems = data.length;
              this.to = Math.min(((this.unpinFromFav)? this.to : this.bulkSize), data.length);
              if(this.unpinFromFav && this.to === this.fullList.length){
                  this.allItemsLoaded = true;
              }
              this.items = data.slice(this.firstBulk,this.to);
              this.isFirstBulk = false;
              this.guestRecordsIdsOrder = this.fullList.map(function(a) {return a.pnx.control.recordid});

              /*Sort favorites in case the URL has a sort by parameter*/
              this.sortFavFromURL(sortBy);
           });
    }

    public getFavoritesTab(){
        return this.favoritesTab;
    }
    public setFavoritesTab(_favoritesTab){
        this.favoritesTab = _favoritesTab;
    }
      get user() {
        if (this.jwtUtilService.isSignedIn()){
             return true;
         }
         return false;

     }

        set user(user) {
          this._user = user;
         }

         
     public nextResults(forceReload) {
         if (!this.isFirstBulk || forceReload){
           let add = Math.min(this.bulkSize,this.fullList.length-this.to);
            if (add > 0) {
               this.from = this.to;
               this.to = this.to + add;
               if (add < this.bulkSize || this.to === this.fullList.length) {
                     this.allItemsLoaded = true;
               }
               if (this.user) {
                   this.start = false;
                   this.getPnxRecordFromRecordId(this.fullList.slice(this.from,this.to));
                 }
                else {
                    this.items = this.fullList.slice(this.firstBulk,this.to);
                 }
            }else{
                this.allItemsLoaded = true;
            }
         }
      }
    
     hasNextResults() {
         return ( !this.allItemsLoaded && this.fullList && (this.fullList.length > this.bulkSize) );
     }



    getSelectedLabels(){
        return this.selectedLabels;
    }


    @preventStateReload
    checkSelectedLabels(label) {
       if (label == "unlabled") {
            this.unlabeledRecords = !this.unlabeledRecords;
         }

        let index = indexOf(this.selectedLabels,label);
        if (index!= -1) {
            this.selectedLabels.splice(index, 1);
            let encode = encodeURIComponent(label);
            let newUrl = this.$location.url().replace("&label="+encode,"");
            this.$location.url(newUrl);
         }
        else {
              this.selectedLabels.push(label);
              this.$location.url(this.$location.url() + "&label=" +label);
         }
        this.returnAllOrFilter();
     }



    returnAllOrFilter() {
        this.allItems = (this.selectedLabels.length == 0)?true:false;
        if (this.allItems) {
            this.getFirstBulkOfAllItems();
         } else {
          this.parseResults();
        }
     }


     iterateOverEachRecord(record) {
        if ((intersection(record.labels,this.selectedLabels).length > 0) ||
                                (record.labels.length == 0 && this.unlabeledRecords)){
           this.countRecords += 1;
           return record.recordId;
          }
         return "";

      }

      private filterEmpty(record) {
          if (record != ""){
               return record;
              }
       }

      parseResults() {
          let selected = [];
          this.countRecords = 0;
          let records = this.getRecords();

          selected = records.map((record) => this.iterateOverEachRecord(record)).filter(this.filterEmpty);
          this.fullList = selected;
          this.to = Math.min(this.bulkSize, selected.length);
          this.start = true;
          this.getPnxRecordFromRecordId(selected.slice(this.firstBulk, this.to));
      }


  @preventStateReload
  clearSelection() {
       this.selectedLabels = [];
       this.allItems= true;
       this.unlabeledRecords = false;
       this.unpinFromFav = false;
       this.getFirstBulkOfAllItems();
       let view = this.$location.search()["vid"];
       this.$location.url("/favorites?vid="+view);
   }

   getCountRecords() {
      return this.countRecords;
   }

    getAllItems() {
     return this.allItems;
    }

    getselectedLabels() {
      return this.selectedLabels;
     }

    get sortInProgress(){
        return this._sortInProgress;
    }

    set sortInProgress(sortInProgress:boolean){
        this._sortInProgress = sortInProgress;
    }
    
    get unpinFromFav(){
        return this._unpinFromFav;
    }

    set unpinFromFav(unpin :boolean){
        this._unpinFromFav = unpin;
    }

    /*
     Sort items on "User" mode.
     Sort recordIds in order to send them to the server and get the record pnx sorted back from the server.
     */
    public sortFavRecordsIds(sortBy) {
        if (sortBy) {
            this.sortBy = sortBy;
        }

        let isReversed	: boolean;

        let getNewestDate = (record) => {
            return new Date(record.creationDate);
        };

        let getTitle = (record) => {

            let title = _get(record,'title');
            if (title) title=title.toLowerCase();
            return title;
        };

        let getAuthor = (record) => {

            let author = _get(record,'author');
            if (author) author=author.toLowerCase();
            return author;
        };

        let tempSortBy;
        switch(this.sortBy){
            case 'date': tempSortBy = getNewestDate; isReversed = true; break;
            case 'title':  tempSortBy = getTitle; isReversed = false; break;
            case 'author':  tempSortBy = getAuthor; isReversed = false; break;
            default: tempSortBy = getNewestDate; isReversed = false;
        }
        let order = isReversed ? 'desc' : 'asc';
        this.records = _orderBy(this.records, [tempSortBy], order);

        this.recordsId = this.records.map(function(a) {return a.recordId;});
    }

    /*
     Sort items on "Guest" mode
     Sort records so we can take firstBulk from it in to this.items.
     */
    public sortFavFullList(sortBy) {
        if (sortBy) {
            this.sortBy = sortBy;
        }
        let isReversed  : boolean;

        let getNewestDate = (item: PI.IDoc) => {
            return this.guestRecordsIdsOrder.indexOf(item.pnx.control.recordid);
        };

        let getTitle = (item: PI.IDoc) => {
            let title = undefined;
            if(item.pnx.display.title !== undefined){
                title = _get(item,'pnx.display.title[0]');
            }
            if (title) title=title.toLowerCase();
            return title;
        };

        let getAuthor = (item: PI.IDoc) => {
            let author = undefined;
            if(item.pnx.display.creator !== undefined){
                author = _get(item,'pnx.display.creator[0]');
            }
            else if(item.pnx.display.contributor !== undefined){
                author = _get(item,'pnx.display.contributor[0]');
            }
            if (author) author=author.toLowerCase();
            return author;
        };

        let tempSortBy;
        switch(this.sortBy){
            case 'date': tempSortBy = getNewestDate; isReversed = false; break;
            case 'title':  tempSortBy = getTitle; isReversed = false; break;
            case 'author':  tempSortBy = getAuthor; isReversed = false; break;
            default: tempSortBy = getNewestDate; isReversed = false;
        }

        let order = isReversed ? 'desc' : 'asc';

        this.fullList = _orderBy(this.fullList, [tempSortBy], order);
    }



    /*
     Gets the sorted items through deep link.
     Will be called when page is loaded.
     */
    public sortFavFromURL(sortBy) {
        this.sortInProgress = true;
        if (this.isLoggedIn()) {
            this.sortFavRecordsIds(sortBy);
            this.fullList = this.recordsId;
        }
        else {
            this.sortFavFullList(sortBy);
            this.to = Math.min(((this.unpinFromFav)? this.to : this.bulkSize) ,this.fullList.length);
            if(this.unpinFromFav && this.to === this.fullList.length){
                this.allItemsLoaded = true;
            }      
            this.items = this.fullList.slice(this.firstBulk,this.to);
            this.isFirstBulk = false;
        }
    }

    /*
     Gets the sort options.
     Will be called when when user click on it on sort favorites dropdown.
     */
    public sortAllFavFromDropdown(sortBy){
        this.runSortInFavoriteBeacon();
        //For deepLink
        if (!sortBy) {
            this.$location.search('sortBy', this.sortBy);
        }
        //End
        this.sortInProgress = true;
        if (this.isLoggedIn()) {
            this.sortFavRecordsIds(sortBy);
            this.fullList = this.recordsId;
        }
        else {
            this.sortFavFullList(sortBy);
            this.to  = Math.min(this.bulkSize,this.fullList.length);
            this.items = this.fullList.slice(this.firstBulk,this.to);
            this.isFirstBulk = false;
        }

    }
   
    private runSortInFavoriteBeacon() {
        let opSortByStr = this.sortBy;
        this.primolyticsService.doBeaconReport({
            'p': 'general',
            'op': 'sortEshelf'+ (opSortByStr.charAt(0).toUpperCase() + opSortByStr.slice(1)),
        }, this.item, this.primolyticsService.getTimestamp());
    }

    get sortBy(){
        return this._sortBy;
    }

    set sortBy(by){
        this._sortBy = by;
    }

    get resultsExists() {
        return !(isEmpty(this.searchService.getResultObject().info));
    };

    get totalResults() {
        if (this.resultsExists) {
            return this.searchService.getResultObject().info.total;
        } else {
            return 0;
        }
    };

    public isLoggedIn(){
        if(this.userSessionManagerService.getUserName())
            return true;
        return false;
    }
    
    public addCameFromPinToFavoritesParam(cameFromString : string) {
        this.searchService.cameFromState = cameFromString;
    } 

    public
    getBulkSize(){
        return this.bulkSize;
    }

}





// WEBPACK FOOTER //
// ./src/main/webapp/components/favorites/favorites.service.ts